import React, { Component } from "react";
import { CardImg, Button, CardTitle, Container } from "reactstrap";
import { Row, Col, Popover, Button as AntButton } from "antd";
import "axios";

import "./styles.css";
import "./chat.style.css";
import "./samard.style.css";
import "./selectchat.style.css";
import "../Feednews/feednews.style.css";

import sandee_ok from "../../assets/chat/sandee_ok.png";
import teamwork_samard from "../../assets/feednews/teamwork_samard.png";
import AIChatbox from "./AIChatbox";
import SAPChangeOwnerChatbox from "./SAPChangeOwnerChatbox";
import GetHelpCxChatbox from "./GetHelpCxChatbox";
import UnlockResetByItOneCxChatBox from "./UnlockResetByItOneCxChatBox";
import UnlockResetAD from "./UnlockResetAD";
import UnlockResetSAP from "./UnlockResetSAP";
import Ariba from "./Ariba";
import guide_book from "../../assets/feednews/guide_book.png";
import sandeeUpdate from "../../assets/feednews/sandee_ai.png";
import checkMark from "../../assets/feednews/CheckMark.png";
import information from "../../assets/chat/i_purple.gif";
import { LanguageContext } from "../../context/LanguageContext";
import { getText } from "../configure/utils";
import { pageConfig } from "../configure/page";
import { takeCampaignFromStorage } from "../../config/campaigns";

// Map components to their names as strings
const componentMap = {
  AIChatbox: AIChatbox,
  SAPChangeOwnerChatbox: SAPChangeOwnerChatbox,
  GetHelpCxChatbox: GetHelpCxChatbox,
  UnlockResetByItOneCxChatBox: UnlockResetByItOneCxChatBox,
  UnlockResetAD: UnlockResetAD,
  UnlockResetSAP: UnlockResetSAP,
  Ariba: Ariba,
};

export default class Chat extends Component {
  static contextType = LanguageContext;
  currentLanguage = null;

  constructor(props) {
    super(props);
    this.state = {
      sateshowflag: false,
      toggleAI: false,
      toggleUnlockResetSAP: false,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
      toggleUnlockResetAD: false,
      toggleAriba: false,
      verifyADPass: false,
      preventPaste: false,
    };
    this.menuADClick = this.menuADClick.bind(this);
    this.menuSAPClick = this.menuSAPClick.bind(this);
    this.menuAribaClick = this.menuAribaClick.bind(this);
    this.menuGenAIClick = this.menuGenAIClick.bind(this);
    this.menuSAPChangeOwnerClick = this.menuSAPChangeOwnerClick.bind(this);
    this.menuGetHelpClick = this.menuGetHelpClick.bind(this);
    this.menuUnlockResetByItOneCxClick = this.menuUnlockResetByItOneCxClick.bind(this);
  }

  componentDidMount() {
    this.currentLanguage = this.context.language;

    if (takeCampaignFromStorage()) {
      this.menuGenAIClick();
    }
  }

  componentDidUpdate() {
    if (this.context.language !== this.currentLanguage) {
      this.currentLanguage = this.context.language;
    }
  }

  menuADClick() {
    if (this.state.toggleUnlockResetAD) {
      const dfMessengerBubble = document.querySelector(".adUnlockReset df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-ad-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({
      toggleAI: false,
      toggleUnlockResetAD: true,
      toggleAriba: false,
      toggleUnlockResetSAP: false,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
    });
  }

  menuSAPClick() {
    if (this.state.toggleUnlockResetSAP) {
      const dfMessengerBubble = document.querySelector(".sapUnlockReset df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-sap-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({
      toggleAI: false,
      toggleUnlockResetAD: false,
      toggleAriba: false,
      toggleUnlockResetSAP: true,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
    });
  }

  menuAribaClick() {
    if (this.state.toggleAriba) {
      const dfMessengerBubble = document.querySelector(".ariba df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-ariba-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({
      toggleAI: false,
      toggleUnlockResetAD: false,
      toggleAriba: true,
      toggleUnlockResetSAP: false,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
    });
  }

  menuGenAIClick() {
    if (this.state.toggleAI) {
      const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-genai-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({
      toggleAI: true,
      toggleUnlockResetAD: false,
      toggleAriba: false,
      toggleUnlockResetSAP: false,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
    });
  }

  menuSAPChangeOwnerClick() {
    if (this.state.toggleSAPChangeOwner) {
      const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-sapchangeowner-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({
      toggleSAPChangeOwner: true,
      toggleAI: false,
      toggleAriba: false,
      toggleUnlockResetSAP: false,
      toggleUnlockResetAD: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
    });
  }

  menuGetHelpClick() {
    if (this.state.toggleGetHelp) {
      const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-gethelp-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({
      toggleSAPChangeOwner: false,
      toggleAI: false,
      toggleAriba: false,
      toggleUnlockResetSAP: false,
      toggleUnlockResetAD: false,
      toggleGetHelp: true,
      toggleUnlockResetByItOne: false,
    });
  }

  menuUnlockResetByItOneCxClick() {
    if (this.state.toggleUnlockResetByItOne) {
      const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-unlock-reset-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({
      toggleSAPChangeOwner: false,
      toggleAI: false,
      toggleAriba: false,
      toggleUnlockResetSAP: false,
      toggleUnlockResetAD: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: true,
    });
  }

  render() {
    const { getHowGoodChatWithSandee, getSelectChat, getAnnouncement } = pageConfig();

    return (
      <div className="sandee-container">
        <section className="box-2">
          <div className="newsamardcard1">
            <div className="cardSamard">
              <Button
                className="buttonClass"
                color="none"
                href="https://sandee-samard.scg.com"
                alt="sandee-samard.scg.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                <Row className="rowSamard">
                  <Col
                    style={{ alignItems: "center" }}
                    xs={{ span: 6 }}
                    sm={{ span: 6 }}
                    md={{ span: 6 }}
                    lg={{ span: 6 }}
                    xl={{ span: 10 }}
                    xxl={{ span: 10 }}
                  >
                    <CardImg src={teamwork_samard} className="samardTeamwork" />
                  </Col>
                  <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 18 }} lg={{ span: 18 }} xl={{ span: 14 }} xxl={{ span: 14 }}>
                    <CardTitle className="card-title-samard">
                      <p className="samardTitleNameStyle athiti-bold">SANDEE-Fix Self Service</p>
                      <div className="Samard_textStyle">
                        <p>{getText("samard.detail")}</p>
                      </div>

                      <div className="clickHere athiti-bold">
                        <a href="https://sandee-samard.scg.com" rel="noopener noreferrer" target="_blank">
                          {getText("samard.click")}
                        </a>
                      </div>
                    </CardTitle>
                  </Col>
                </Row>
              </Button>
            </div>
          </div>
        </section>

        <section className="box-1">
          <div className="newfeaturecard">
            <Row className="feedNews athiti-bold">NEWS FEED</Row>
            <Row className="articleStyle">
              <Col style={{ alignItems: "center" }} xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }}>
                <CardImg src={sandeeUpdate} className="newUpdate" />
              </Col>
              <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 18 }} lg={{ span: 18 }} xl={{ span: 20 }}>
                <CardTitle className="titleNameStyle athiti-bold">
                  <div className="newFeatureTextStyle">
                    <p className="blick-button athiti-bold">ASK! SANDEE AI New Feature</p>
                  </div>
                  <p className="newFeatureTextStyleTitle">
                    <b>{getText("sandee_helping.head")}</b>
                  </p>
                  {getText("sandee_helping.content").map((text, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center" }}>
                      <img src={checkMark} alt="checkMark" width={30} />
                      <p className="newFeatureTextStyle blackText">{text}</p>
                    </div>
                  ))}
                  <div className="line"></div>

                  <br />

                  <p className="newFeatureTextStyleTitle">
                    <b>{getText("how_good.head")}</b>
                  </p>
                  {getHowGoodChatWithSandee().map((item, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center" }}>
                      <img src={item.imgSrc} alt={`icon-${index}`} width={30} />
                      <p className="newFeatureTextStyle blackText">{item.text}</p>
                    </div>
                  ))}
                </CardTitle>
              </Col>
            </Row>

            {getAnnouncement(this.currentLanguage).map((item, index) => (
              <Row key={index} className="articleStyle">
                <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }}>
                  <CardImg src={item.imageSrc} width={item.width} className="imageStyle" />
                </Col>
                <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 18 }} lg={{ span: 18 }} xl={{ span: 20 }}>
                  {" "}
                  <CardTitle className="announceLayout">
                    <CardTitle className="newFeatureTextStyleTitle athiti-bold">
                      {item.title}
                      <p className="newFeatureTextStyle blackText">{item.disscription}</p>
                      <div className="readMore athiti-bold">
                        <a href={item.href} rel="noopener noreferrer" target="_blank">
                          {item.click}
                        </a>
                      </div>
                    </CardTitle>
                  </CardTitle>
                </Col>
              </Row>
            ))}
          </div>
        </section>

        <section className="box-3">
          <div className="cardSelectChat">
            <CardTitle className="bannerSelectChat athiti-bold">
              <b>SANDEE</b>
            </CardTitle>
            <div className="contrainer-chat">
              {getSelectChat(this.currentLanguage).map((chatItem, index) => {
                const ConditionComponent = componentMap[chatItem.conditionComponent];
                // const content = index === 0 && (
                //   <div>
                //     {chatItem.content.map((item, index) => (
                //       <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                //         <img src={checkMark} alt="checkMark" width={30} />
                //         <p className="newFeatureTextStyle blackText" style={{ marginLeft: "10px" }}>
                //           {item}
                //         </p>
                //       </div>
                //     ))}
                //   </div>
                // );

                const title = index === 0 && (
                  <p className="chatbot-Wel-Message">
                    <b>&emsp;Sandee Chatbot</b> {getText("welcome1")}
                    <p className="tab">{getText("welcome2")}</p>
                    {/* <b>{chatItem.title}</b> */}
                  </p>
                );

                return (
                  <Row key={index} className={`rowSelectChatStyle ${chatItem.chatColor}`}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 20 }} lg={{ span: 20 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="balloon">
                          <CardImg className="imageSelectChatStyle" src={chatItem.imageSrc} />
                        </div>
                        <Button className={`buttonSelectChatStyle ${chatItem.buttonClass}`} value={chatItem.buttonValue} onClick={this[chatItem.onClick]}>
                          <p className="textSelectChat">{chatItem.buttonText}</p>
                        </Button>
                        {this.state[chatItem.conditionKey] && ConditionComponent && <ConditionComponent />}

                        {index === 0 && ( //display แค่ index แรก
                          <Popover
                            overlayClassName="responsive-popover"
                            // placement="topLeft"
                            title={title}
                            // content={content}
                            trigger="hover"
                          >
                            <AntButton type="text" style={{ padding: 0, border: "none" }}>
                              <img src={information} alt="information" width={40} />
                            </AntButton>
                          </Popover>
                        )}

                        {index !== 0 && ( //ไม่ใช่ index แรก จะล่องหน
                          <Popover
                            // placement="topLeft"
                            title={title}
                            // content={content}
                          >
                            <AntButton type="text" style={{ opacity: 0, cursor: "default", padding: 0, border: "none" }}>
                              <img src={information} alt="information" width={40} />
                            </AntButton>
                          </Popover>
                        )}
                      </div>
                    </Col>
                  </Row>
                );
              })}
            </div>
            <div className="SANDEE-UserManual">
              <Row>
                <Col span={24}>
                  <img className="imgBook-SANDEE-UserManual" src={guide_book} width={30}></img>
                  <a
                    href="https://scg.service-now.com/myrequestscg?id=u_kb_article&sys_id=92ab3ba4db241450c48ef0eb0c9619b1"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    วิธีการ Unlock & Reset
                  </a>
                </Col>
              </Row>
            </div>
            <Container>
              <img alt="" className="SandeeOK" src={sandee_ok} />
            </Container>
          </div>
        </section>
      </div>
    );
  }
}
